<template>
    <div>
        <keep-alive :include="keepAliveNameList">
            <router-view/>
        </keep-alive>
    </div>
</template>
<script>
export default {
    components: {},
    data() {
        return {
            keepAliveNameList: ["WorkUserSearch"]
        }
    },
    created() {
    },
    methods: {}
}
</script>

<style lang="scss" scoped>

</style>
